import { render } from "./RegisterMember.vue?vue&type=template&id=10eee6de&scoped=true"
import script from "./RegisterMember.vue?vue&type=script&lang=js"
export * from "./RegisterMember.vue?vue&type=script&lang=js"

import "./RegisterMember.vue?vue&type=style&index=0&id=10eee6de&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10eee6de"]])

export default __exports__